import React from 'react';
import { processSteps } from '../data/mockData';
import { useLanguage } from '../i18n/LanguageContext';

const ProcessSection = () => {
  const { t } = useLanguage();

  const processStepsTranslated = (t('process.steps') || []).map((step, i) => ({
    ...step,
    number: String(i + 1).padStart(2, '0'),
  }));

  return (
    <section id="proceso" className="py-16 md:py-24 px-6 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <p
            className="inline-block rounded-full border border-black/15 bg-black/5 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-black/60 mb-5"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            {t('process.badge')}
          </p>
          <h2 className="text-4xl sm:text-5xl font-semibold tracking-tight leading-[1.05] mb-4">{t('process.title')}</h2>
          <p className="text-base md:text-lg text-black/55 leading-relaxed max-w-3xl mx-auto">
            {t('process.description')}
          </p>
        </div>

        <div className="border-t border-black/10">
          {processStepsTranslated.map((step, index) => (
            <article
              key={index}
              className="grid grid-cols-[auto,1fr] gap-4 md:gap-6 py-6 md:py-7 border-b border-black/10"
            >
              <div className="pt-1">
                <span className="inline-block min-w-[2.2rem] bg-transparent border-0 rounded-none p-0 text-[11px] font-medium tracking-[0.18em] text-black/35">
                  {step.number}
                </span>
              </div>

              <div>
                <h3 className="text-xl md:text-2xl font-semibold tracking-tight text-black mb-2">{step.title}</h3>
                <p className="text-sm md:text-base text-black/55 leading-relaxed">{step.description}</p>
                <p className="mt-3 text-xs md:text-sm text-black/40">
                  {step.tags.join(' · ')}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;